module.exports = __webpack_public_path__ + "static/media/header-17.c0232fea.jpg";